import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import classes from "./PdfViewerComponent.module.scss";

// @react-pdf-viewer/core usa pdfjs-dist 3.x; la ruta build/ existe en v3 (en v4+ está en legacy/build/)
const PDF_WORKER_URL = "https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js";

const PdfViewerComponent = ({ pdfContent }) => {
    try {
        return (
            <div className={classes.container}>
                <Worker workerUrl={PDF_WORKER_URL}>
                    <Viewer fileUrl={pdfContent} httpHeaders={{
                        'Accept': 'application/pdf',
                        "Content-Type": "application/pdf"
                    }}
                        defaultScale={SpecialZoomLevel.PageFit}
                    />
                </Worker>
            </div>
        );
    } catch (error) {
        console.error('Error:', error);
        return <div>Error al cargar el PDF</div>;
    }
};


export default PdfViewerComponent;